import LicensesUtils from '@/composables/LicensesUtils';
const { getTimeNowPlusSeconds } = LicensesUtils()

export default {
    namespaced: true,
    state: {
        isWebView: false,
        applicationAuthorizationCallback: null,
        applicationCode: null,
        applicationBundleId: null,
        applicationName: null,
        applicationInstanceId: 0,
        machineSerial: null,
        applicationGlobalInfo: null,
        currentActivationsSerials: [],
        licenses: [],
        isMigration: false

    },
    actions: {
    },
    mutations: {
        setIsWebView(state) {
            state.isWebView = true;
        },
        setApplicationAuthorizationCallback(state, newApplicationAuthorizationCallback) {
            state.applicationAuthorizationCallback = newApplicationAuthorizationCallback;
        },
        clearApplicationAuthorizationCallback(state) {
            state.applicationAuthorizationCallback = null;
        },
        setApplicationCode(state, newApplicationCode) {
            state.applicationCode = newApplicationCode;
        },
        clearApplicationCode(state) {
            state.applicationCode = null;
        },
        setApplicationBundleId(state, newApplicationBundleId) {
            state.applicationBundleId = newApplicationBundleId;
        },
        clearApplicationBundleId(state) {
            state.applicationBundleId = null;
        },
        setApplicationName(state, newApplicationName) {
            state.applicationName = newApplicationName;
        },
        clearApplicationName(state) {
            state.applicationName = null;
        },
        setApplicationInstanceId(state, newApplicationInstanceId) {
            state.applicationInstanceId = newApplicationInstanceId;
        },
        updateApplicationInstanceId(state) {
            const instanceBundleId = state.applicationBundleId
            const globalBundleId = (state.applicationGlobalInfo && state.applicationGlobalInfo.unique_bundle_id) ? state.applicationGlobalInfo.unique_bundle_id : null
            if (instanceBundleId) {
                if (globalBundleId && instanceBundleId.startsWith(globalBundleId)) { // We have all the info and bundle id matches the app global one: interpret the instance id by substracting
                    const instanceIdString = instanceBundleId.slice(globalBundleId.length);
                    const instanceId = parseInt(instanceIdString, 10);
                    state.applicationInstanceId = !isNaN(instanceId) ? instanceId : 0;
                }
                else { // We miss the app global bundle id, but we will try to find the id from the bundle id only (looking at the number at the end)
                    const instanceIdString = instanceBundleId.match(/\d+$/);
                    if (instanceIdString) {
                        const instanceId = parseInt(instanceIdString[0], 10);
                        state.applicationInstanceId = !isNaN(instanceId) ? instanceId : 0;
                    } else { // can't find a number at the end of the bundle id
                        state.applicationInstanceId = 0;
                    }
                }
            }
            else { // if we don't have the actual application bundle id, we can't find the instance id and consider it to be 0
                state.applicationInstanceId = 0;
            }
        },
        clearApplicationInstanceId(state) {
            state.applicationBundleId = 0;
        },
        setMachineSerial(state, newMachineSerial) {
            state.machineSerial = newMachineSerial;
        },
        clearMachineSerial(state) {
            state.machineSerial = null;
        },
        setApplicationGlobalInfo(state, newApplicationGlobalInfo) {
            state.applicationGlobalInfo = newApplicationGlobalInfo;
        },
        clearApplicationGlobalInfo(state) {
            state.applicationGlobalInfo = null;
        },
        setCurrentActivationsSerials(state, newCurrentActivationsSerials) {
            state.currentActivationsSerials = newCurrentActivationsSerials;
        },
        clearCurrentActivationsSerials(state) {
            state.currentActivationsSerials = [];
        },
        addCurrentActivationSerial(state, addedSerial) {
            // Make sure the serial number is not already in the array : add only if not yet
            if (!state.currentActivationsSerials.includes(addedSerial)) {
                state.currentActivationsSerials = [...state.currentActivationsSerials, addedSerial]
            }
        },
        removeCurrentActivationSerial(state, removedSerial) {
            state.currentActivationsSerials = state.currentActivationsSerials.filter((serial) => serial !== removedSerial)
        },
        setLicenses(state, newLicenses) {
            // Add a Dictionary element => activation (info for the current status)
            const licensesInfoWithActivationsKey = newLicenses.map(obj => {
                let res = {...obj}
                // If pending status, calculate the local time of expiration based on the number of seconds
                if (res.pending) {
                    if (res.pending.pending_release) {
                        res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                    }
                    if (res.pending.pending_reactivate) {
                        res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                    }
                }
                return res
            })
            state.licenses = licensesInfoWithActivationsKey;
        },
        clearLicenses(state) {
            state.licenses = [];
        },
        addLicense(state, addedLicenseInfo) {
            // Make sure the license is not already in the array : add only if not yet
            if (!state.licenses.some((license) => license.serial_number == addedLicenseInfo.serial_number)) {
                let res = {...addedLicenseInfo}
                // If pending status, calculate the local time of expiration based on the number of seconds
                if (res.pending) {
                    if (res.pending.pending_release) {
                        res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                    }
                    if (res.pending.pending_reactivate) {
                        res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                    }
                }
                state.licenses.push(res)
            }
        },
        updateLicenseCurrentStatus(state, newCurrentStatusInfo) {
            // Update the current_status for the serial number
            state.licenses = state.licenses.map((license) => {
                if (license.serial_number === newCurrentStatusInfo.serial_number) {
                    return { ...license, ['current_status']: newCurrentStatusInfo.current_status }
                }
                return license
            })
        },
        updateLicenseCurrentStatusAndPendingInfo(state, newInfo) {
            // Update the current status and the pending info for the serial number
            state.licenses = state.licenses.map((license) => {
                if (license.serial_number === newInfo.serial_number) {
                    // Replace the current status
                    let res = { ...license, current_status: newInfo.current_status }
                    // Update pending info = Remove pending info + Add new pending info if there is
                    delete res.pending
                    if (newInfo.pending) {
                        res = {...res, pending: {...newInfo.pending}}
                        if (newInfo.pending.pending_release) {
                            res = {...res, pending: {...res.pending, pending_release: {...res.pending.pending_release, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_release.remaining_time_s)}}}
                        }
                        if (newInfo.pending.pending_reactivate) {
                            res = {...res, pending: {...res.pending, pending_reactivate: {...res.pending.pending_reactivate, exp_datetime: getTimeNowPlusSeconds(res.pending.pending_reactivate.remaining_time_s)}}}
                        }
                    }
                    return res
                }
                return license
            })
        },
        setIsMigration(state, newIsMigration) {
            state.isMigration = newIsMigration;
        },
        clearIsMigration(state) {
            state.isMigration = false;
        },
    },
    getters: {
    }
};